/**
 * useStudentTutoringData — la lecture de « Messages » : le compte.
 *
 * Les tuteurs et leurs non-lus viennent du compte, relu par la coquille à chaque retour sur
 * l'espace (`BottomTabsNavigator`). Le bouton de relecture de la page le relit (`getUser`), le
 * tirer-pour-rafraîchir de l'écran legacy. Les prochaines séances ne se lisent plus ici : elles ont
 * quitté l'onglet (Wajih, 18/10) pour l'accueil et « Tous mes lives ».
 */
import { useCallback } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { authService } from "../../../../../../data/services/authService"

export function useStudentTutoringData() {
    const dispatch = useDispatch()

    const refresh = useCallback(() => {
        dispatch(apiRequest(authService.getUser) as never)
    }, [dispatch])

    return { refresh }
}
